module.exports = __webpack_public_path__ + "img/gallery_w.19fa2dde.svg";